module.exports = __webpack_public_path__ + "img/chess-clock.e4b87abf.svg";